"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var common_1 = require("docs/common");
var components_1 = require("components");
var description = 'This is a simple example on how use modal.' +
    ' Click on button and modal will open.';
var code = "import React from 'react';\nimport { Button, Modal } from 'jsc-react-ui';\n\nclass Example extends React.Component {\n  state = {\n    modalOpen: false,\n  };\n\n  render() {\n    const { modalOpen } = this.state;\n\n    return (\n      <div>\n        <Button\n          onClick={this.handleButtonClick}\n        >\n          Open modal\n        </Button>\n\n        <Modal\n          open={modalOpen}\n          onClose={this.handleOnModalClose}\n        />\n      </div>\n    );\n  }\n\n  handleButtonClick = () => {\n    this.setState({modalOpen: true});\n  }\n\n  handleOnModalClose = () => {\n    this.setState({modalOpen: false});\n  }\n}";
var SimpleExample = (function (_super) {
    __extends(SimpleExample, _super);
    function SimpleExample() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            modalOpen: false,
        };
        _this.handleButtonClick = function () {
            _this.setState({ modalOpen: true });
        };
        _this.handleOnModalClose = function () {
            _this.setState({ modalOpen: false });
        };
        return _this;
    }
    SimpleExample.prototype.render = function () {
        var modalOpen = this.state.modalOpen;
        return (React.createElement(common_1.Example, { title: "Simple", description: description, code: code },
            React.createElement(components_1.Button, { onClick: this.handleButtonClick }, "Open modal"),
            React.createElement(components_1.Modal, { open: modalOpen, onClose: this.handleOnModalClose })));
    };
    return SimpleExample;
}(react_1.PureComponent));
exports.SimpleExample = SimpleExample;



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ModalPage/SimpleExample.tsx
// module id = 700
// module chunks = 0